/**
 * Under the pictures: what the chosen treatment does, contextual notes, «Как это работает», disclaimer.
 * The visual-acuity table was removed from the page on the expert's request (D-026); the estimate stays in
 * optics/va.ts and its tests.
 */

import { t, tl, type Lang } from '../i18n';
import { h } from './dom';

export interface NoteLine {
  text: string;
  /** Contextual warning (amber marker) vs plain description. */
  warning: boolean;
}

export interface Readout {
  el: HTMLElement;
  setNotes(title: string, lines: NoteLine[]): void;
}

export function buildReadout(lang: Lang): Readout {
  const notesTitle = h('h3');
  const notesList = h('ul', { class: 'notes' });
  const how = h('details', { class: 'card how' },
    h('summary', { text: t(lang, 'how') }),
    h('ol', {}, ...tl(lang, 'how.items').map((item) => h('li', { text: item }))),
  );
  const el = h('section', { class: 'readout' },
    h('div', { class: 'card notes-card' }, notesTitle, notesList),
    how,
    h('p', { class: 'disclaimer', text: t(lang, 'disclaimer') }),
  );

  return {
    el,
    setNotes(title, lines) {
      notesTitle.textContent = title;
      notesList.replaceChildren(...lines.map((line) => h('li', { class: line.warning ? 'warning' : '', text: line.text })));
    },
  };
}
